import script from "./SubscriptionAccessGuard.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionAccessGuard.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionAccessGuard.vue?vue&type=style&index=0&id=34207625&scoped=true&lang=css"

import exportComponent from "/opt/bitnami/projects/OrganiCuentas/front_end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34207625"]])

export default __exports__